<template>
  <div class="container-datepicker">
    <v-date-picker
      v-model="input"
      v-bind="$attrs"
      :class="[{ disabled }, ...classNames]"
      :mode="mode"
      :locale="getLang"
      :popover="{
        visibility: 'focus',
      }"
      :masks="{
        input: dateformat,
      }"
      :attributes="[
        {
          dot: {
            color: 'gray',
          },
          dates: [new Date()],
        },
      ]"
      color="green"
      @dayclick="handleDayclick"
    >
      <template v-slot="{ inputValue, inputEvents }">
        <input
          :value="inputValue"
          :disabled="disabled"
          class="form-control"
          v-on="inputEvents"
        >
      </template>
    </v-date-picker>
    <div
      v-if="disabled"
      class="overey"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  inheritAttrs: false,

  props: {
    value: {
      type: Boolean | String | Number | Object | Array,
    },
    disabled: {
      type: Boolean,
    },
    classNames: {
      type: String | Object | Array,
    },
    mode: {
      type: String,
      default: 'date',
    },
  },

  data () {
    return {
      input: null,
    }
  },

  computed: {
    ...mapGetters({
      dateformat: 'getDateFormat',
      getLang: 'getLang',
    }),
  },

  watch: {
    input () {
      this.$emit('input', this.input)
    },
    value () {
      this.input = this.value
    },
  },

  created () {
    this.input = this.value
  },

  methods: {
    handleDayclick() {
      this.$emit('dayclick')
    },
  },
}
</script>

<style scoped>
.container-datepicker {
  position: relative;
}

.container-datepicker /deep/ .is-invalid input {
  border-color: #ea848d;
}

.container-datepicker /deep/ .is-invalid input:focus {
  box-shadow: 0 0 0 0.2rem rgba(220,53,69,.25);
}

.overey {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.container-datepicker /deep/ .popover-origin {
  z-index: 201;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseInputDatePicker.vue